<template>
    <b-modal
      id="generic-error-modal"
      ref="modal"
      v-model="isModalVisible"
      :title="modalTitle"
      centered
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      button-size="sm"
      footer-class="p-2 border-top-0"
    >
      <div class="d-block text-center">
        <p class="mb-0">{{ modalMessage }}</p>
      </div>
      <template #modal-footer>
        <b-button variant="primary" @click="closeModal">
          {{ $t('Okay') || 'Tamam' }}
        </b-button>
      </template>
    </b-modal>
  </template>
  
  <script>
  import { BModal, BButton } from 'bootstrap-vue'
  
  export default {
    name: 'GenericErrorModal',
    components: {
      BModal,
      BButton,
    },
    data() {
      return {
        isModalVisible: false,
        modalTitle: '',
        modalMessage: '',
        onCloseCallback: null,
        timeoutId: null,
      }
    },
    methods: {
      openModal(title, message, onCloseCallback = null) {
        this.modalTitle = title || (this.$t('Error') || 'Hata'); // Default title
        this.modalMessage = message;
        this.onCloseCallback = onCloseCallback;
        this.isModalVisible = true;

        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }

        this.timeoutId = setTimeout(() => {
          console.log("Modal auto-close timeout reached.");
          if(this.isModalVisible) {
             this.closeModal();
          }
        }, 3000);
      },
      closeModal() {
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
          this.timeoutId = null;
        }

        if (typeof this.onCloseCallback === 'function') {
          try {
            this.onCloseCallback();
          } catch (e) {
            console.error("Error executing modal close callback:", e);
          }
        }

        this.isModalVisible = false;
        this.modalTitle = '';
        this.modalMessage = '';
        this.onCloseCallback = null;
      },
    },
  }
  </script>
  
  <style lang="scss" scoped>
  // Add any specific styles if needed
  </style>